import MissingInputCheck from './missing-input';
import ErrorHandling from './error-handling';

const FormHelpers = {
	checkboxLimit(checkboxes, checkedCheckboxes, limit, elementToShow, allowedMoreThanLimit) {
		this.checkboxes = checkboxes;
		this.checkedCheckBoxes = checkedCheckboxes;
		this.limit = limit;
		this.elementToShow = elementToShow;
		this.allowedMoreThanLimit = allowedMoreThanLimit;
		this.hideClass = allowedMoreThanLimit ? 'hidden' : 'error-msg--hidden';
		for (let i = 0; i < checkboxes.length; i += 1) {
			this.checkCheckboxLimit(checkboxes[i]);
		}
	},

	checkCheckboxLimit(checkbox) {
		checkbox.addEventListener('click', () => {
			if (this.elementToShow) {
				this.elementToShow.classList.add(this.hideClass);
			}
			if (checkbox.checked) {
				this.checkedCheckBoxes += 1;
			} else {
				this.checkedCheckBoxes -= 1;
			}
			this.showMessageElement(this.checkedCheckBoxes, checkbox);
		});
	},

	createErrorBlock(input) {
		input.classList.add('input--error', 'invalid');

		const errorBlockId = input.dataset.errorBlock;
		const errorBlock = document.getElementById(errorBlockId);
		if (errorBlock) errorBlock.classList.remove('error-msg--hidden');
	},

	removeErrorBlock(input) {
		input.classList.remove('input--error', 'invalid');

		const errorBlockId = input.dataset.errorBlock;
		const errorBlock = document.getElementById(errorBlockId);
		if (errorBlock) errorBlock.classList.add('error-msg--hidden');
	},

	validateRadioButtons(inputs) {
		const radios = [];
		inputs.forEach((input) => {
			if (
				input.type === 'radio' &&
				(input.hasAttribute('required') || input.dataset?.validation === 'required')
			) {
				radios.push(input);
			}
		});
		const questions = Object.values(
			radios.reduce(
				(result, el) => Object.assign(result, { [el.name]: (result[el.name] || []).concat(el) }),
				{}
			)
		);

		questions.forEach((question) => {
			if (!question.some((el) => el.checked)) {
				question.forEach((el) => {
					el.classList.add('input--error', 'invalid');
				});
			}
		});

		return questions.some((question) => !question.some((el) => el.checked));
	},

	cleanUpErrorMessages(errorMessages) {
		errorMessages.forEach((errorBlockId, i) => {
			const errorBlock = document.getElementById(errorBlockId);
			if (errorBlock) document.getElementById(errorBlockId).classList.add('error-msg--hidden');
			errorMessages.splice(i, 1);
		});
	},

	missingInputCheck(currentTabContainer, e) {
		// Exit function if nudge for missing input is needed:
		const missingInput = currentTabContainer?.dataset?.missingInput;
		if (missingInput) {
			return MissingInputCheck.checkMissingInput(currentTabContainer, e);
		}
		return true;
	},

	showMessageElement(checkedCount, checkbox) {
		if (checkedCount > this.limit) {
			if (!this.allowedMoreThanLimit) {
				const checkBox = checkbox;
				checkBox.checked = false;
				this.checkedCheckBoxes -= 1;
			}
			if (this.elementToShow) {
				this.elementToShow.classList.remove(this.hideClass);
			}
		}
	},

	setProgressBar(progressBar, currentTabNr, totalTabs) {
		const percentageFilled = (currentTabNr * 100) / (totalTabs.length - 1);
		if (currentTabNr === 0 || percentageFilled === 0) {
			progressBar.classList.add('hidden');
		} else {
			progressBar.classList.remove('hidden');
		}
		if (percentageFilled !== 0) {
			const progressBarFilled = progressBar.querySelector('.progress-bar-filled__container');
			progressBarFilled.style.width = `${percentageFilled}%`;
			progressBarFilled.innerHTML = `<span class="progress--alt"></span>`;
		}
	},

	tabCounter(totalTabs, currentTab) {
		document.querySelector('.wizard__counter').innerText = `${currentTab + 1}/${totalTabs}`;
	},

	validateFormByTab(errorMessages, currentTab) {
		if (errorMessages.length > 0) {
			errorMessages.length = 0;
		}

		const tabInputs = Array.from(currentTab.querySelectorAll('input, select, textarea'));
		return ErrorHandling(tabInputs);
	},

	validateImageUploadExtension(targetElement) {
		if (targetElement.querySelectorAll('[data-validate-image]').length > 0) {
			const validExtensions = ['.jpg', '.jpeg', '.svg', '.png'];
			Array.from(targetElement.querySelectorAll('[data-validate-image]')).forEach(
				(imageUploadElement) => {
					imageUploadElement.addEventListener('change', () => {
						this.validateExtension(imageUploadElement, validExtensions);
					});
				}
			);
		}
	},

	validateFileUploadExtension(targetElement) {
		if (targetElement.querySelectorAll('[data-validate-file]').length > 0) {
			const validExtensions = ['.jpg', '.jpeg', '.pdf', '.doc', '.docx'];
			Array.from(targetElement.querySelectorAll('[data-validate-file]')).forEach(
				(fileUploadElement) => {
					fileUploadElement.addEventListener('change', () => {
						this.validateExtension(fileUploadElement, validExtensions);
					});
				}
			);
		}
	},

	validateExtension(imageUploadElement, validExtensions) {
		const errorBlockId = imageUploadElement.dataset.errorBlock;
		const errorBlock = document.getElementById(errorBlockId);
		if (!errorBlock.classList.contains('error-msg--hidden')) {
			errorBlock.classList.add('error-msg--hidden');
			imageUploadElement.classList.remove('input--error', 'invalid');
		}
		if (imageUploadElement.type === 'file') {
			const fileName = imageUploadElement.value;
			let valid = false;
			for (let i = 0; i < validExtensions.length; i += 1) {
				const currentExtension = validExtensions[i];
				if (
					fileName
						.substr(fileName.length - currentExtension.length, currentExtension.length)
						.toLowerCase() === currentExtension.toLowerCase()
				) {
					valid = true;
					break;
				}
			}
			if (!valid) {
				imageUploadElement.classList.add('input--error', 'invalid');
				if (imageUploadElement.dataset.errorBlock) {
					if (errorBlock) errorBlock.classList.remove('error-msg--hidden');
				}
				return false;
			}
		}
		return true;
	},

	setRecommendedProjectTemplates(searchField, result, index, inputId) {
		const input = document.getElementById(inputId);
		if (!this.inputArray) {
			this.inputArray = [];
		}

		const searchInput = searchField;
		this.inputArray[index] = result.key;
		input.value = this.inputArray.join(',');
		searchInput.value = result.name;

		this.keys = this.inputArray;
	},
};

export default FormHelpers;
